import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import DashboardPage from './DashboardPage';
import SuperAdminDashboard from './SuperAdminDashboard';

const DashboardRouter = () => {
  const { user } = useAuth();
  
  if (!user) {
    return <Navigate to="/login" />;
  }
  
  // Super Admin goes to special dashboard
  if (user.role === 'super_admin') {
    return <SuperAdminDashboard />;
  }
  
  // Sellers go to sales page
  if (user.role === 'seller') {
    return <Navigate to="/seller-sales" />;
  }
  
  // Regular admins go to normal dashboard
  return <DashboardPage />;
};

export default DashboardRouter;
